import { AppLink, Button, Callout } from "@amber/ui";
import type { Duplicate } from "../../contracts/index";

export function DuplicateNotice({
  duplicate,
  decided,
  onDifferent,
  onComplete,
}: {
  duplicate: Duplicate;
  decided: boolean;
  onDifferent: () => void;
  onComplete: (() => void) | null;
}) {
  if (decided) {
    return (
      <p className="m-0 text-md text-muted">
        Recorded as a different person from{" "}
        <AppLink href={`/profiles/${duplicate.id}`} className="text-link underline">
          {duplicate.name}
        </AppLink>
        .
      </p>
    );
  }
  return (
    <Callout
      tone="waiting"
      title={
        <>
          {duplicate.name} already exists{" "}
          <span className="font-normal text-muted">
            · {duplicate.state_label}
            {duplicate.role ? ` · ${duplicate.role}` : ""}
          </span>
        </>
      }
      actions={
        <>
          {onComplete ? (
            <Button size="sm" variant="primary" onClick={onComplete}>
              Use this identity for it
            </Button>
          ) : null}
          <AppLink
            href={`/profiles/${duplicate.id}`}
            className="inline-flex h-7 items-center rounded-lg border border-border bg-bg px-2.5 text-md font-strong text-fg no-underline hover:bg-surface-2"
          >
            Open it
          </AppLink>
          <Button size="sm" variant="ghost" onClick={onDifferent}>
            Different person
          </Button>
        </>
      }
    >
      {duplicate.reason}.
      {onComplete ? " The draft can take this Wikipedia identity instead of creating a second profile." : ""}
    </Callout>
  );
}
